import { create } from "zustand";

export const useProfileDetailsSheetStore = create((set) => ({
  isOpen: false,
  highlightKey: null,
  open: (highlightKey = null) => set({ isOpen: true, highlightKey }),
  clearHighlight: () => set({ highlightKey: null }),
  close: () => set({ isOpen: false, highlightKey: null }),
}));
